import { render, staticRenderFns } from "./DSBadges.vue?vue&type=template&id=6b751c1d&"
import script from "./DSBadges.vue?vue&type=script&lang=js&"
export * from "./DSBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports